module.exports = __webpack_public_path__ + "static/media/wt3.b6e3cd74.png";